import * as yup from "yup";

export const validationBoqSchema = yup.object().shape({
  project_id: yup.number().required(),
  boq_name: yup.string().label("BOQ name").required(),
  description: yup.string().label("description").required(),
  vendor_id: yup.number().nullable(),
  vendor_name: yup.string().nullable().optional(),
  qty: yup.number().nullable().optional(),
  mr_unit_id: yup.number().nullable().optional(),
  price: yup.number().nullable().optional(),
  budget: yup.number().label("Budget").required(),
  actual:yup.number().nullable().optional(),
  variance:yup.number().nullable().optional(),
  start_date: yup.string().label("Start Date").required(),
  due_date : yup.string().label("Due Date").required(),
  project_boq_id: yup.number().nullable().optional(),
  status: yup.number().nullable().optional(),
  checklist_status: yup.number().nullable().optional(),
  checklist_date: yup.string().nullable().optional(),
  project_file: yup.array().of(yup.object().shape({
    project_file_id: yup.number().optional(),
    project_file_name: yup.string().optional(),
    path: yup.string().nullable().optional(),
  })).optional(),
});

export const validationFormBoqSchema =  yup.object().shape({
    data_boq:yup.array().of(validationBoqSchema).min(1, "At least one item must be filled in").required("Data BOQ is required"),
})
export type DataBoqType = yup.InferType<typeof validationBoqSchema>;
export type FormBoqType = yup.InferType<typeof validationFormBoqSchema>;